import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { LOOKUP } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { HlookupsAddMultipleComponent } from '../hlookups-add-multiple/hlookups-add-multiple.component';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-hlookups-modal-edit',
  templateUrl: './hlookups-modal-edit.component.html',
  styleUrls: ['./hlookups-modal-edit.component.scss']
})
export class HlookupsModalEditComponent implements OnInit {
  @Input() public Content: any;
 // content: any;
  //heading: string;
  isAllowNew: boolean = false;
  lookupList: LOOKUP[];
  lookupListVal: LOOKUP;
  hideActive: boolean = false;
  action: Subject<any> = new Subject();
  Module: any;
  Modulecode:any;
  lookup: LOOKUP;

  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public _modelRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    debugger;
    if (this.Content.IsAllowNew == "Yes" || this.Content.heading == "Edit" || this.Content.heading == "Add")
      this.isAllowNew = true;
    else
      this.isAllowNew = false;
    this.getLookups();
  }

  getLookups() {
    this.summaryService.getHLookupsSummary(this.Content.id).subscribe(summary => {
      this.lookupList = summary;
    });
  }

  selectDocuments(event, firstLevelId, lookup) {
    let ISParent = true;
    if ((firstLevelId != undefined && firstLevelId != null && firstLevelId != "") || firstLevelId?.CODE == "PARENT") {
      ISParent = false;
    }

    if (event == "Add" || event == "AddChild") {
      if(event == "Add"){
        this.Content.heading = "Add";
      } else{
        this.Content.heading = "AddChild";
      }
      let modalRef = this.modalService.open(HlookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: this.Content.heading,
          id: this.Content.id,
          IsParent: ISParent,
          FirstLevelID: firstLevelId,
          Module: this.Content.Module,
          parentName: lookup == undefined ? "" : lookup.NAME,
          list: this.lookupList

      }

      // modalRef.content.action.subscribe(result => {
      //   let exist = true;
      //   if (result && event == "Add") {
      //     result["ChildData"] = [];
      //     if (result.ID == null) {
      //       result.ID = this.commonService.getUniqueId();
      //     }
      //     if (this.lookupList.length > 0) {
      //       this.lookupList.forEach(element => {
      //         if (element.NAME == result.NAME) {
      //           this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The' + result.NAME + ' already exists. Please update the details to save the value' } } });
      //         } else {
      //           this.lookupList.push(result);
      //           this.commonService.SuccessBanner(result.NAME + ' details inserted successfully');
      //         }
      //       });
      //     } else {
      //       this.lookupList.push(result);
      //       this.commonService.SuccessBanner(result.NAME + ' details inserted successfully');
      //     }

      //   } else {
      //     if (result.ID == null || result.ID == undefined) {
      //       result.ID = this.commonService.getUniqueId();
      //     }
      //     this.lookupListVal = this.lookupList.find(x => (x.NAME == result.DEFAULT_ID) || (x.ID == result.DEFAULT_ID));
      //     this.lookupListVal["ChildData"].forEach(element => {
      //       if (element.NAME == result.NAME) {
      //         this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The' + result.NAME + ' already exists. Please update the details to save the value' } } });
      //         exist = false;
      //       }
      //     });
      //     if (exist) {
      //       this.lookupListVal["ChildData"].push(result);
      //       this.commonService.SuccessBanner(result.NAME + ' details inserted successfully');
      //     }
      //   }
      // });
    }

    if (event == "Edit") {
      let modalRef = this.modalService.open(HlookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg ',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Edit',
          id: this.Content.id, IsParent: ISParent, FirstLevelID: lookup.ID, Module: this.Content.Module,
          Name: lookup.NAME, RecordState: lookup.RECORD_STATE,
          list: this.lookupList

      }
      modalRef.result.then(result => {
        if (result) {
          let isExist = this.lookupList.find(x => x.NAME == result.NAME && x.RECORD_STATE == result.RECORD_STATE);
          if (!isExist) {
            let find = this.lookupList.findIndex(x => x.ID == result.ID);
            this.lookupList[find].NAME = result.NAME;
            this.lookupList[find].RECORD_STATE = result.RECORD_STATE;
            //this.commonService.SuccessBanner(result.NAME + ' details updated successfully');
          }
          // else if (isExist.ID != null) {
          //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The ' + isExist.NAME + 'already exists. Please update the details to save the value' } } });
          // }
          // else {
          //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been performed' } } });
          // }

        }
      });
    }

    if (event == "EditChild") {
      let modalRef = this.modalService.open(HlookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg ',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Edit',
          id: this.Content.id, IsParent: ISParent, FirstLevelID: firstLevelId, Module: this.Content.Module,
          Name: lookup.NAME, RecordState: lookup.RECORD_STATE, parentName: firstLevelId.NAME, ID: lookup.ID, list: this.lookupList, head : "EditChild"

      }
      modalRef.result.then(result => {
        let lkup: any;
        let find: any;
        if (result) {
          lkup = this.lookupList.find(x => x.ID == result.DEFAULT_ID);
          let isExist = lkup["ChildData"].find(x => x.NAME == result.NAME && x.RECORD_STATE == result.RECORD_STATE);
          if (!isExist) {
            find = lkup["ChildData"].findIndex(x => x.ID == result.ID);
            lkup["ChildData"][find].NAME = result.NAME;
            lkup["ChildData"][find].RECORD_STATE = result.RECORD_STATE;
            //this.commonService.SuccessBanner(result.NAME + ' details updated successfully');

          }
          //  else {
          //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been performed' } } });
          // }
        }
      });
    }
  }

  Save(): void {
    //debugger;
    let subValList = [];
    let childExist = true;
    let suprtValName = "";
    let program = "";
    let module = "";
    this.lookupList.forEach(element => {
      if (element["ChildData"].length == 0) {
        childExist = false;
        suprtValName = element.NAME;
        subValList.push(suprtValName);
      }
    });

    if (this.lookupList.length >= 1) {
      if (childExist) {
        for (let i = 0; i < this.lookupList.length; i++) {
          if (this.lookupList[i].RECORD_STATE)
            this.lookupList[i].RECORD_STATE = 1;
          else
            this.lookupList[i].RECORD_STATE = 0;

          for (let j = 0; j < this.lookupList[i]["ChildData"].length; j++) {
            if (this.lookupList[i]["ChildData"][j].RECORD_STATE)
              this.lookupList[i]["ChildData"][j].RECORD_STATE = 1;
            else
              this.lookupList[i]["ChildData"][j].RECORD_STATE = 0;
          }

          this.lookupList[i]["CATEGORY"] = this.Content.Name;
          this.lookupList[i]["PROGRAM"] = this.Content.Module;
        }

        this.summaryService.updateHLookups(this.lookupList).subscribe(summary => {
          // this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been updated successfully.' } } });
          if (summary.Status === 0) {
            this.commonService.SuccessBanner(this.Content.Name + ' details updated successfully');
          //  this.action.next();
            this.close();
          } else {
            // this.commonService.ErrorBanner(summary.Message);
            this.commonService.ValidationBanner(summary.Message);
          }

        });
      } else {
        this.commonService.ValidationBanner("Please add sub-values against " + subValList.join(', ') + " to save the details");
        // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please add sub-values against ' + suprtValName + ' to save the details' } } });
      }
    } else {
      this.commonService.ValidationBanner("Please add at least one value to save the configuration");
      // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please add at least one value to save the configuration' } } });
    }

  }

  Delete(event, lookupId): void {

    let checkSingle = this.lookupList.find(x => x.ID == lookupId);
    if (checkSingle['ChildData'].length > 0) {
      // this.modalRef = this.modalService.show(DeleteBoxComponent, {
      //   backdrop: false,
      //   keyboard: false,
      //   ignoreBackdropClick: true,
      //   animated: true,
      //   data: {
      //     heading: "Delete",
      //     custommessage: "Are you sure you want to delete this Sub Value " + event.NAME
      //     // ProceedButtonName:"Delete",
      //     // TerminateButtonName:"Cancel"
      //   }
      // });
      // this.modalRef.content.action.subscribe(result => {
      //   if (result == 'okclick') {
        event.ParentID = lookupId;
          this.summaryService.deleteHLookups(event).subscribe(summary => {
            if (summary.Status === 0) {
              this.commonService.ValidationBanner(summary.Message);
              // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: summary.Message } } });

              //this.commonService.ErrorBanner(summary.message);
            }
            else {
              let val = this.lookupList.find(x => x.ID == lookupId);
              let listVal = val["ChildData"].findIndex(x => x.ID == event.ID);
              // if (val["ChildData"].length == 1) {
              //   this.commonService.ValidationBanner("At least one value should present");
              //   // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'At least one value should present' } } });
              // }

              if (val["ChildData"].length > 0) {

                val["ChildData"].splice(listVal, 1);
                //this.commonService.SuccessBanner(val["ChildData"][listVal].NAME + ' details deleted successfully');
              }
            }
          });
      //   }
      // })
    }
  }

  validateChild() {
    let childExist = true;
    this.lookupList.forEach(element => {
      if (this.lookupList["ChildData"].length < 0) {
        childExist = false;
      }
    });
    return childExist;
  }

  listSorted(event: any) {
    // this.lookupList  = {...this.lookupListCopy};
    // this.lookupList = this.lookupListCopy;
   // console.log(event);
  }

  close() {
    this._modelRef.dismiss();
  }

}
